const COLORS = {
  markers: "#EB383E",
};
export default COLORS;
